const EMPLOYER_STATUSES = {
    PENDING: 'Pending',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

export default EMPLOYER_STATUSES;
